'use es6';

import { combineReducers } from 'redux';
import auth from 'simple-menus-core/reducers/Auth';
import tree from 'simple-menus-core/reducers/MenuTree';
import nodesById from 'simple-menus-core/reducers/MenuNodes';
import pages from 'simple-menus-core/reducers/Pages';
import application from 'simple-menus-core/reducers/Application';
export default combineReducers({
  application,
  auth,
  tree,
  nodesById,
  pages
});